import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const CITY_MIN_LENGTH = 2;
const POSTAL_CODE_PATTERN = /^\d{5}$/;

export function cityMinLengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const city = control.value as string;

    if (city && city.length > 0 && city.length < CITY_MIN_LENGTH) {
      return { companyCityTooShort: { message: 'register.error.city_short' } };
    }

    return null;
  };
}

export function companyPostalCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const postalCode = control.value as string;

    if (postalCode && !POSTAL_CODE_PATTERN.test(postalCode)) {
      return { companyPostalCode: { message: 'register.error.postal_code_format' } };
    }

    return null;
  };
}
